import { Grid } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useState } from 'react';
import { BiFilterAlt } from 'react-icons/bi';
import { ICandidateSubmissionSearchFilterVM, IJobCandidateInteraction } from 'wisestep-api';
import {
  WsButton,
  WsDrawer,
  WsMoreOptionButton,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import WsJobsCrmPipelineAdvanceFilters from '../../../../components/filters/jobsCrmPipeline';
import JobsCrmPipelineAdvanceFiltersFormProps from '../../../../components/filters/models/JobsCrmPipelineAdvanceFiltersFormProps';
import CardWrapper from '../../../../features/automatedEmailCampaignSettings/childRoutes/CardWrapper';
import AdvancedFilters from '../../../../features/submissionsNew/components/filters/advanced';
import {
  getDefaultFilterValues,
  ISubmissionAdvanceFilters,
  processUserInputsToFilters,
} from '../../../../features/submissionsNew/utils/Helper';
import {
  defaultSimilarJobsSubmissionQuery,
  updateAdvancedQuery,
} from '../../utils/similarJobsHelper';

interface SimilarJobsHeaderProps {
  submissionQuery: ICandidateSubmissionSearchFilterVM;
  mappingQuery: IJobCandidateInteraction;
  updateSubmissionQuery: (updatedSubmissionQuery: ICandidateSubmissionSearchFilterVM) => void;
  updateMappingsQuery: (updatedMappingQuery: IJobCandidateInteraction) => void;
  filterType: 'Mappings' | 'Submission';
}

const SimilarJobsHeader = ({
  submissionQuery,
  mappingQuery,
  updateSubmissionQuery,
  updateMappingsQuery,
  filterType,
}: SimilarJobsHeaderProps) => {
  const [openAdvancedFilters, setOpenAdvancedFilters] = useState<boolean>(false);
  const [sumbissionAdvancedFilters, setSumbissionAdvancedFilters] =
    useState<ISubmissionAdvanceFilters>(getDefaultFilterValues(submissionQuery));
  const [mappingAdvancedFilters, setMappingAdvancedFilters] =
    useState<JobsCrmPipelineAdvanceFiltersFormProps>({});
  const toggleOpenAdvancedFilters = () => setOpenAdvancedFilters((prev) => !prev);

  const onApplyFilters = (data: JobsCrmPipelineAdvanceFiltersFormProps) => {
    setMappingAdvancedFilters(data);
    updateMappingsQuery(updateAdvancedQuery(data, mappingQuery));
  };

  const onFormSubmit = (data: ISubmissionAdvanceFilters) => {
    toggleOpenAdvancedFilters();
    const processedFilters = isEmpty(data) ? [] : processUserInputsToFilters(data);
    const updatedQuery = { ...submissionQuery, filters: processedFilters, page: 0 };
    if (isEmpty(data)) {
      updateSubmissionQuery({ ...defaultSimilarJobsSubmissionQuery() });
      setSumbissionAdvancedFilters({} as ISubmissionAdvanceFilters);
    } else {
      setSumbissionAdvancedFilters(data);
      updateSubmissionQuery(updatedQuery);
    }
  };
  return (
    <CardWrapper sx={{ pt: 0 }}>
      <Grid xs={12} display="flex" alignItems="center" justifyContent="space-between">
        <Grid item xs={2}>
          <WsTypography variant={WsTypoVariants.TITLE} bold>
            Similar Jobs
          </WsTypography>
        </Grid>
        <Grid item>
          <Grid display="flex" columnGap={1} alignItems="center">
            <WsButton
              className="advance-filter"
              variant="outlined"
              size="medium"
              onClick={toggleOpenAdvancedFilters}
              startIcon={<BiFilterAlt size={18} />}
            >
              Advanced filters
            </WsButton>

            <WsMoreOptionButton
              items={['Export Candidates']}
              onItemClick={(item) => console.log(item)}
            />
          </Grid>
        </Grid>
      </Grid>
      {openAdvancedFilters &&
        (filterType === 'Submission' ? (
          <WsDrawer
            title="Advanced Filters"
            open={true}
            onClose={toggleOpenAdvancedFilters}
            size="small"
            headerSize="small"
          >
            <AdvancedFilters
              onClose={toggleOpenAdvancedFilters}
              defaultValues={sumbissionAdvancedFilters}
              onSubmit={onFormSubmit}
            />
          </WsDrawer>
        ) : (
          <WsJobsCrmPipelineAdvanceFilters
            open={true}
            onApplyFilters={(data: JobsCrmPipelineAdvanceFiltersFormProps) => {
              onApplyFilters(data);
            }}
            filterClose={toggleOpenAdvancedFilters}
            defaultValues={mappingAdvancedFilters}
          />
        ))}
    </CardWrapper>
  );
};

export default SimilarJobsHeader;
